export default function FindingReportController(
  $q,
  $rootScope,
  $scope,
  alerts,
  amDataService,
  confirmDialog,
  loaderService,
  ssDialogService
) {
  const vm = this;

  // Set Default Values
  vm.canExpand = vm.status !== 'No Finding Report Added';
  vm.isExpanded = false;
  vm.canDeleteItem = vm.canDelete;

  // Attach Event Handlers
  vm.handleUnattachFindingReport = _handleUnattachFindingReport;
  vm.handleConfirmDelete = _handleConfirmDelete;
  vm.handleCancelDelete = _handleCancelDelete;

  function _handleUnattachFindingReport($event) {
    ssDialogService.dialogs.auditTrail.deleteFindingReportConfirmDialog = ssDialogService.alert(
      confirmDialog.getOptions($event, {
        dialogTitle: 'Remove Attached Report?',
        message: `Are you sure you want to remove Report "${vm.findingReport.name}"?`,
        handleYesClick: _handleConfirmDelete,
        handleNoClick: _handleCancelDelete,
      })
    );

    ssDialogService.show(ssDialogService.dialogs.auditTrail.deleteFindingReportConfirmDialog);
  }

  function _handleConfirmDelete() {
    loaderService.showViewLoader = true;
    return amDataService.detachFindingReport(vm.findingReport.findingReportInstanceId)
      .then(() => {
        alerts.success('The report has been removed successfully.');
        $rootScope.$broadcast('refreshAMFindingReports', { findingId: vm.findingReport.findingId });
        _closeDeleteDialog();
      }).catch(() => {
        alerts.error('Error occurred while removing the report.');
      }).finally(() => {
        loaderService.showViewLoader = false;
      });
  }

  function _handleCancelDelete() {
    _closeDeleteDialog();
  }

  function _closeDeleteDialog() {
    ssDialogService.hide(ssDialogService.dialogs.auditTrail.deleteFindingReportConfirmDialog);
  }
}

FindingReportController.$inject = [
  '$q',
  '$rootScope',
  '$scope',
  'alerts',
  'amDataService',
  'confirmDialog',
  'loaderService',
  'ssDialogService'
];
